import { mapState } from 'vuex'
export default {
  data() {
    return {
      fullscreen: false,
      currentMessage: null,
      messageTimer: null,
      t: null, // 定时器
      changeYellow: 1,
      posList: [],
      copyCurP: null,
      maxScale: 9, // 可以缩放到的最大倍数
      minScale: 1, // 可以缩放到的最小倍数
      baseScale: 0.5 // 每次缩放的基数
    }
  },
  computed: {
    ...mapState('book', ['isZoom', 'pages', 'isMobile', 'totalPage', 'currentZoom', 'start', 'translate', 'isShowTitle', 'isShowCommerHeader']),
    currentPage() {
      let currentPageArray = this.$store.state.book.currentPage
      let page
      if (currentPageArray[0] === 0) {
        page = currentPageArray[1] + '/' + this.totalPage
      } else if (currentPageArray[1] === 0) {
        page = currentPageArray[0] + '/' + this.totalPage
      } else {
        page = currentPageArray.join(' - ') + '/' + this.totalPage
      }
      return page
    },
    currentPageNum() {
      return this.currentPage.split('/')[0]
    },
    splitCurrentPage() {
      let page
      if (this.currentPageNum.indexOf('-') > -1) {
        page = this.currentPageNum.split('-')[1]
      } else {
        page = this.currentPageNum
      }
      return page
    },
    currentPageArray() {
      return this.$store.state.book.currentPage
    },
    bookH() {
      return this.$store.state.common.bookHeight
    },
    bookHeight() {
      return this.$store.state.common.bookSize.bookHeight
    },
    bookWidth() {
      return this.$store.state.common.bookSize.bookWidth
    },
    bookScale() {
      return this.$store.state.common.bookScale
    },
    goodsObj() {
      return this.$store.state.common.goodsObj
    },
    needPay() {
      return false
    }
  },
  watch: {
    currentPage(newCurrentPage) {
      this.pageMessage = newCurrentPage
    }
  },
  methods: {
    // 提示：第一页与最后一页的公共方法
    pageLimtMessage(message) {
      if (this.currentMessage) {
        this.currentMessage.message = message
        this.currentMessage.visible = true
        this.messageTimer && clearTimeout(this.messageTimer)
        this.messageTimer = setTimeout(() => {
          this.currentMessage.visible = false
        }, 1500)
      } else {
        this.currentMessage = this.$message({
          customClass: this.isMobile ? 'el-message-class-mobile' : 'el-message-class-pc',
          duration: 0,
          message: message
        })
        this.messageTimer = setTimeout(() => {
          this.currentMessage.visible = false
        }, 1500)
      }
    },
    pageLastLimt() {
      if (Number(this.splitCurrentPage) === this.totalPage) {
        this.pageLimtMessage('这是最后一页')
      }
    },
    pageFirstLimt() {
      if (Number(this.splitCurrentPage) === 1) {
        this.pageLimtMessage('这是第一页')
      }
    },
    inputFocus() {
      this.pageMessage = ''
    },
    inputBlur() {
      this.pageMessage = this.currentPage
    },
    toPage(pageEvent, interval, lock) {
      if (lock == 'lock') {
        if (this.pageMessage >= this.totalPage) {
          this.stopFlip()
        }
      }
      if (this.isZoom) {
        $('#book').turn('disable', false)
      }
      if (this.isMobile) {
        $('#book').turn('disable', false)
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
      }
      this.$nextTick(() => {
        switch (pageEvent) {
          case 'enter':
            if (this.pageMessage > this.totalPage) {
              this.pageLimtMessage('这是最后一页')
              $('#book').turn('page', this.totalPage)
            } else if (this.pageMessage < 1) {
              this.pageLimtMessage('这是第一页')
              $('#book').turn('page', 1)
            } else {
              $('#book').turn('page', this.pageMessage)
            }
            this.$store.commit('book/UPDATE_CURRENT_PAGE', $('#book').turn('view'))
            this.pageMessage = this.currentPage
            break
          case 'next':
            this.pageLastLimt()
            $('#book').turn('next')
            break
          case 'previous':
            this.pageFirstLimt()
            $('#book').turn('previous')
            break
          case 'first':
            this.pageFirstLimt()
            $('#book').turn('page', 1)
            break
          case 'last':
            this.pageLastLimt()
            $('#book').turn('page', this.totalPage)
            break
        }
      })
    },
    // 放大
    enlarge() {
      if (this.currentZoom >= this.maxScale) {
        return false
      }
      this.clearMoveAdjust()
      let _zoom = Number((this.currentZoom + this.baseScale).toFixed(1))
      this.$store.commit('book/UPDATE_IS_ZOOM', true)
      this.$store.commit('book/UPDATE_ZOOM', _zoom)
      $('.book-viewport').css({ transform: 'matrix(' + this.currentZoom + ', 0, 0, ' + this.currentZoom + ',' + this.translate.oldX + ',' + this.translate.oldY + ')', transition: 'none 0s ease 0s' })
    },
    // 缩小
    narrow() {
      let _zoom = Number((this.currentZoom - this.baseScale).toFixed(1))
      if (_zoom >= this.minScale) {
        this.clearMoveAdjust()
        _zoom == 1 ? this.$store.commit('book/UPDATE_IS_ZOOM', false) : this.$store.commit('book/UPDATE_IS_ZOOM', true)
        this.$store.commit('book/UPDATE_ZOOM', _zoom)
        $('.book-viewport').css({
          transform: 'matrix(' + this.currentZoom + ', 0, 0, ' + this.currentZoom + ',' + this.translate.oldX + ',' + this.translate.oldY + ')',
          transition: 'none 0s ease 0s'
        })
      }
    },
    // 清除移动补偿
    clearMoveAdjust() {
      const bookDom = document.getElementById('fd-book')
      bookDom.style.top = null
      bookDom.style.left = null
    },
    // 全屏
    fullScreenClick() {
      let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement

      if (isFullScreen) {
        exitFullscreen.call(this)
      } else {
        console.log(document.documentElement)
        launchFullscreen.call(this, document.documentElement)
      }

      function launchFullscreen(element) {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullScreen()
        }
      }

      function exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      }
    },
    // 自动翻页
    autoFlip(interval, lock) {
      if (this.t) {
        clearInterval(this.t)
        this.t = setInterval(() => {
          this.toPage('next', interval, lock)
        }, interval)
      } else {
        this.t = setInterval(() => {
          this.toPage('next', interval, lock)
        }, interval)
      }
    },
    // 停止自动翻页
    stopFlip() {
      if (this.t) {
        clearInterval(this.t)
      }
    }
  }
}
